import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useTheme,
  useMediaQuery,
  CardContent,
  Card,
  Grid,
  DialogContent,
  DialogActions,
  InputAdornment,
  IconButton,
  Theme,
  Chip,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatchWrapper } from "../../../hooks";
import { useBillingCompanyContext } from "../../../providers";
import {
  IAudienceListItem,
  IMarketCampaignAudience,
} from "../../../redux/marketCampaign/marketCampaign.types";
import { RightPanel } from "../../../components/RightPanel";
import {
  CustomCheckbox,
  CustomFormLabel,
  CustomTextField,
} from "../../../components/formsComponents";

import {
  saveQuickSendCampaignAsync,
  upsertDraftStepAsync,
} from "../../../redux/marketCampaign/marketCampaignActions";
import { showMessage } from "../../../redux/messages/messagesActions";
import { CustomDatePicker } from "../../../components/formsComponents/CustomDatePicker";
import { Close, NavigateBefore } from "@mui/icons-material";
import { Dialog } from "../../../components/Dialogs/Dialog";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "../../../hooks/useDebounce";
import { useMarketCampaignContext } from "../MarketCampaign.context-state";
import LoadingDialog from "../../../components/Dialogs/LoadingDialog";
import { MuiNumberField } from "../../../components/formsComponents/MuiNumberField";
import CustomSwitch from "../../../components/customSwitch/customSwitch";
import { extractHeaders } from "../../marketingCampaign/components/ExcelFileUplaodButtonAsyncV2";
import { useTimezoneFormatter } from "../../../hooks/useTimezoneFormatter";

const EXCLUDED_COMPARE_FIELDS = [
  "id",
  "check",
  "status",
  "initialCheck",
  "isRecordUpdated",
  "currentPageNo",
];

interface IPreviewSelectedAudieneRightPanelProps {
  open: boolean;
  totalContactRecords?: number;
  onClose: () => void;
  onComplete: () => void;
  mode: "VIEW_AUDIENCE" | "QUICK_SEND";
  audienceData?: IMarketCampaignAudience;
}

export const PreviewSelectedAudieneRightPanel: React.FC<
  IPreviewSelectedAudieneRightPanelProps
> = ({
  open,
  onClose,
  onComplete,
  mode,
  audienceData,
  totalContactRecords,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();
  const { ftDate } = useTimezoneFormatter();
  const {
    isEditable,
    state,
    draftSteps: draftStepData,
    marketCampaign: campaignBasicInfo,
    onStateChange,
  } = useMarketCampaignContext();

  const marketCampaignId = campaignBasicInfo.market_campaign_uuid;
  const newQuickSendList = audienceData?.market_campaign_audience_list;

  let tableHeaders = extractHeaders(newQuickSendList || []);

  if (!tableHeaders.includes("check")) {
    tableHeaders = ["check"].concat(tableHeaders);
  }

  // const {
  //   list: quickSendList,
  //   headers: tableHeaders,
  //   totalRecords,
  // } = useReduxStore("marketCampaign").marketCampaignQuickSend;

  // const [rowsList, setRowsList] = React.useState<any[]>(quickSendList);
  const [rowsList, setRowsList] = React.useState<any[] | undefined>(
    newQuickSendList,
  );
  const [localRowList, setLocalRowList] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [openDialog, setOpenDialog] = useState(false);
  const [contactNumberSearch, setContactNumberSearch] = useState("");
  const [guestNameSearch, setGuestNameSearch] = useState("");
  const [showOverwriteDialog, setShowOverwriteDialog] = useState(false);
  const [existingRowData, setExistingRowData] = useState<any>(null);
  const [newRowData, setNewRowData] = useState<any>(null);
  const [editedRowsMap, setEditedRowsMap] = React.useState<Record<string, any>>(
    {},
  );
  const [isSaving, setIsSaving] = useState(false);
  const [isIncludeSelected, setIsIncludeSelected] = useState(false);
  const [newAudience, setNewAudience] = useState<IAudienceListItem>({
    phone: "",
    name: "",
    check: 0,
    isRecordUpdated: false,
    initialCheck: 0,
    currentPageNo: 1,
  });
  const [requiredFieldsError, setRequiredFieldsError] = useState({
    phone: false,
    name: false,
  });

  const resetNewAudience = () => {
    setNewAudience({
      phone: "",
      name: "",
      check: 0,
      isRecordUpdated: false,
      initialCheck: 0,
      currentPageNo: 1,
    });
  };

  const debouncedContactNumber = useDebounce(contactNumberSearch, 500);
  const debouncedGuestName = useDebounce(guestNameSearch, 500);

  // const updatedRowsList = React.useMemo(() => {
  //   return Object.values(editedRowsMap)
  //     .filter((row: any) => row.isRecordUpdated)
  //     .map(
  //       ({ isRecordUpdated, initialCheck, currentPageNo, ...rest }: any) => ({
  //         ...rest,
  //         check: rest.check ? 1 : 0,
  //       }),
  //     );
  // }, [editedRowsMap]);

  const updatedRowsList = React.useMemo(() => {
    return Object.values(editedRowsMap)
      .filter((row: any) => row.isRecordUpdated)
      .map(
        ({
          isRecordUpdated,
          initialCheck,
          currentPageNo,
          check,
          ...rest
        }: any) => ({
          ...rest,
        }),
      );
  }, [editedRowsMap]);

  const selectedAudienceOperationData = React.useMemo(() => {
    return rowsList
      ?.filter((row) => {
        // INCLUDE → selected rows
        if (isIncludeSelected) {
          return row.check === 1;
        }

        // EXCLUDE → unselected rows
        return row.check === 0;
      })
      .map(
        ({
          isRecordUpdated,
          initialCheck,
          currentPageNo,
          check,
          ...rest
        }: any) => ({
          ...rest,
        }),
      );
  }, [rowsList, isIncludeSelected]);

  const handleSaveSuccess = () => {
    setEditedRowsMap({});
  };

  const filteredLocalRows = React.useMemo(() => {
    return localRowList.filter((row) => {
      const phoneMatch = debouncedContactNumber
        ? row.phone?.toString().includes(debouncedContactNumber)
        : true;
      const nameMatch = debouncedGuestName
        ? row.name?.toLowerCase().includes(debouncedGuestName.toLowerCase())
        : true;
      return phoneMatch && nameMatch;
    });
  }, [localRowList, debouncedContactNumber, debouncedGuestName]);

  const combineLocalAndReduxList = React.useMemo(() => {
    if (!rowsList) return;
    return [...filteredLocalRows, ...rowsList];
  }, [filteredLocalRows, rowsList]);

  // const totalCombinedRecords = React.useMemo(() => {
  //   return totalRecords + filteredLocalRows.length;
  // }, [totalRecords, filteredLocalRows.length]);

  const totalCombinedRecords = React.useMemo(() => {
    return newQuickSendList?.length || 0 + filteredLocalRows.length;
  }, [newQuickSendList, filteredLocalRows.length]);

  const displayRows = React.useMemo(() => {
    const localRowsCount = filteredLocalRows.length;
    const startIndex = page * rowsPerPage;

    if (page === 0) {
      return combineLocalAndReduxList?.slice(0, rowsPerPage);
    } else {
      if (rowsList && startIndex < localRowsCount) {
        const localPart = filteredLocalRows.slice(
          startIndex,
          startIndex + rowsPerPage,
        );
        const remainingSlots = rowsPerPage - localPart.length;
        const reduxPart = rowsList.slice(0, remainingSlots);

        return [...localPart, ...reduxPart];
      }
      return rowsList;
    }
  }, [
    page,
    rowsPerPage,
    filteredLocalRows,
    rowsList,
    combineLocalAndReduxList,
  ]);

  const selectedCustomers = React.useMemo(() => {
    const localSelected = localRowList.filter((x) => x.check === 1).length;
    const reduxSelected = rowsList?.filter((x) => x.check === 1).length || 0;
    return localSelected + reduxSelected;
  }, [localRowList, rowsList]);

  const allChecked = React.useMemo(() => {
    if (!rowsList) return;
    const allRows = [...localRowList, ...rowsList];
    return allRows.length > 0 && allRows.every((x) => x.check === 1);
  }, [localRowList, rowsList]);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCheckBoxAll = (
    _: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    const newCheckValue = checked ? 1 : 0;

    /** 🔹 1. Update LOCAL rows (no edited map needed) */
    setLocalRowList((prev) =>
      prev.map((row) => ({
        ...row,
        check: newCheckValue,
      })),
    );

    /** 🔹 2. Update REDUX rows + editedRowsMap */
    setEditedRowsMap((prev) => {
      const updated = { ...prev };

      rowsList?.forEach((row) => {
        const key = row.phone.toString().trim();
        const baseline = prev[key] ?? row;

        updated[key] = {
          ...baseline,
          check: newCheckValue,
          isRecordUpdated: baseline.initialCheck !== newCheckValue,
        };
      });

      return updated;
    });

    /** 🔹 3. Update rowsList for immediate UI feedback */
    setRowsList((prev) =>
      prev?.map((row) => ({
        ...row,
        check: newCheckValue,
        isRecordUpdated: row.initialCheck !== newCheckValue,
      })),
    );
  };

  const handleCheckBox =
    (phone: string) =>
    (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const key = phone.toString().trim();
      const newCheckValue = checked ? 1 : 0;

      /** 🔹 CASE 1: Local rows */
      const localRowIndex = localRowList.findIndex(
        (row) => row.phone?.toString().trim() === key,
      );

      if (localRowIndex !== -1) {
        setLocalRowList((prev) =>
          prev.map((row, index) =>
            index === localRowIndex ? { ...row, check: newCheckValue } : row,
          ),
        );
        return; // ✅ stop here
      }

      /** 🔹 CASE 2: Redux rows */
      const reduxRow = rowsList?.find(
        (row) => row.phone?.toString().trim() === key,
      );

      if (!reduxRow) return;

      setEditedRowsMap((prev) => {
        const baseline = prev[key] ?? reduxRow;

        return {
          ...prev,
          [key]: {
            ...baseline,
            check: newCheckValue,
            isRecordUpdated: baseline.initialCheck !== newCheckValue,
          },
        };
      });

      setRowsList((prev) =>
        prev?.map((row) =>
          row.phone?.toString().trim() === key
            ? {
                ...row,
                check: newCheckValue,
                isRecordUpdated: row.initialCheck !== newCheckValue,
              }
            : row,
        ),
      );
    };

  const handleSaveAndNextAsync = async () => {
    const key = `campaign_${marketCampaignId}_save_and_next_clicked`;
    localStorage.setItem(key, "true");

    setIsSaving(true);
    const sanitizedHeaders = (tableHeaders || []).filter(
      (header) => header !== "check",
    );

    dispatch(
      saveQuickSendCampaignAsync(
        {
          market_campaign_uuid: marketCampaignId || "",

          quick_send_list: {
            new_audience_added: localRowList,
            headers: sanitizedHeaders,
            audience_list_uuids:
              audienceData?.market_campaign_audience_list_uuids || [],
            selected_audience_list_operation: {
              data: selectedAudienceOperationData || [],
              check: isIncludeSelected ? 1 : 0,
            },
          },
        },
        (data) => {
          dispatch(
            upsertDraftStepAsync(
              {
                ...draftStepData,
                current_step: 2,
                draft_step_data: {
                  ...draftStepData.draft_step_data,
                  step_two_data: {
                    ...draftStepData.draft_step_data?.step_two_data,
                    saveQuickSendCampaignData: data,
                    audienceData: audienceData,
                    hasClickedSaveAndNext: true,
                  },
                },
              },
              (draftState) => {
                onStateChange({
                  ...state,
                  draftSteps: draftState,
                  completionSteps: {
                    ...state.completionSteps,
                    step2: true,
                  },
                  activeStep: 2,
                  maxAllowedSteps: 2,
                });
                onComplete();
              },
            ),
          );

          handleSaveSuccess();
        },
      ),
    );
  };

  // const handleSaveAndNextAsync = async () => {
  //   const key = `campaign_${marketCampaignId}_save_and_next_clicked`;
  //   localStorage.setItem(key, "true");

  //   setIsSaving(true);

  //   dispatch(
  //     saveQuickSendCampaignAsync(
  //       {
  //         market_campaign_uuid: marketCampaignId || "",
  //         quick_send_list: updatedRowsList,
  //         new_quick_send_list: localRowList,
  //         check_all: allChecked,
  //       },
  //       (data) => {
  //         //  setLocalRowList([]);
  //         dispatch(
  //           upsertDraftStepAsync(
  //             {
  //               ...draftStepData,
  //               current_step: 2,
  //               draft_step_data: {
  //                 ...draftStepData.draft_step_data,
  //                 step_two_data: {
  //                   ...draftStepData.draft_step_data?.step_two_data,
  //                   saveQuickSendCampaignData: data,
  //                   audienceData: audienceData,
  //                   hasClickedSaveAndNext: true,
  //                 },
  //               },
  //             },
  //             (draftState) => {
  //               onStateChange({
  //                 ...state,
  //                 draftSteps: draftState,
  //                 completionSteps: {
  //                   ...state.completionSteps,
  //                   step2: true,
  //                 },
  //                 activeStep: 2,
  //                 maxAllowedSteps: 2,
  //               });
  //               onComplete();
  //             },
  //           ),
  //         );

  //         handleSaveSuccess();
  //       },
  //     ),
  //   );

  //   // setLocalRowList([]);
  // };

  const handleNext = () => {
    onStateChange({ ...state, activeStep: 2, maxAllowedSteps: 2 });
  };

  const handleCreateAudience = async () => {
    try {
      if (
        !newAudience.phone ||
        !newAudience.name ||
        newAudience.phone.length !== 10
      ) {
        setRequiredFieldsError({
          phone: !newAudience.phone,
          name: !newAudience.name,
        });
        return;
      }

      if (newAudience.phone) {
        const data = {
          phone: newAudience.phone || "",
          name: newAudience.name || "",

          ...Object.fromEntries(
            tableHeaders
              .filter(
                (header) => !["check", "id", "phone", "name"].includes(header),
              )
              .map((header) => [
                header,
                newAudience[header as keyof typeof newAudience] || "",
              ]),
          ),
          check: 1,
        };

        const normalizedNewPhone = data.phone?.toString().trim();

        const isDuplicateInRowsList = rowsList?.some(
          (x) => x.phone?.toString().trim() === normalizedNewPhone,
        );

        const isDuplicateInLocalRowsList = localRowList.some(
          (x) => x.phone?.toString().trim() === normalizedNewPhone,
        );

        if (!isDuplicateInRowsList && !isDuplicateInLocalRowsList) {
          const newLocalRowList = [{ ...data, check: 1 }, ...localRowList];

          setLocalRowList(newLocalRowList);
          setOpenDialog(false);
          resetNewAudience();
          setPage(0);
          setRequiredFieldsError({
            phone: false,
            name: false,
          });

          dispatch(
            showMessage({
              type: "success",
              message: "Audience added successfully",
              displayAs: "snackbar",
            }),
          );
        } else if (isDuplicateInLocalRowsList) {
          const existingRow = localRowList.find(
            (x) => x.phone?.toString().trim() === normalizedNewPhone,
          );

          if (existingRow) {
            const differences = getFieldDifferences(existingRow, data);
            if (differences.length > 0) {
              setExistingRowData(existingRow);
              setNewRowData(data);
              setShowOverwriteDialog(true);
            } else {
              dispatch(
                showMessage({
                  type: "warning",
                  message:
                    "Contact number already exists with the same information",
                  displayAs: "snackbar",
                }),
              );
            }
          } else {
            dispatch(
              showMessage({
                type: "error",
                message: "Contact number already exists in the audience list",
                displayAs: "snackbar",
              }),
            );
          }
        } else {
          const existingRow = rowsList?.find(
            (x) => x.phone?.toString().trim() === normalizedNewPhone,
          );

          if (existingRow) {
            const differences = getFieldDifferences(existingRow, data);
            if (differences.length > 0) {
              setExistingRowData(existingRow);
              setNewRowData(data);
              setShowOverwriteDialog(true);
            } else {
              dispatch(
                showMessage({
                  type: "warning",
                  message:
                    "Contact number already exists with the same information",
                  displayAs: "snackbar",
                }),
              );
            }
          } else {
            dispatch(
              showMessage({
                type: "error",
                message: "Contact number already exists in the audience list",
                displayAs: "snackbar",
              }),
            );
          }
        }
      }
    } catch (error) {
      dispatch(
        showMessage({
          type: "error",
          message: "Failed to create audience",
          displayAs: "snackbar",
        }),
      );
    }
  };

  const handleOverwriteConfirm = () => {
    if (existingRowData && newRowData) {
      const normalizedPhone = existingRowData.phone?.toString().trim();

      const existingLocalIndex = localRowList.findIndex(
        (row) => row.phone?.toString().trim() === normalizedPhone,
      );

      if (existingLocalIndex !== -1) {
        const updatedLocalRowsList = [...localRowList];
        updatedLocalRowsList[existingLocalIndex] = {
          ...newRowData,
          check: 1,
        };
        setLocalRowList(updatedLocalRowsList);
      } else {
        const existingReduxIndex = rowsList?.findIndex(
          (row) => row.phone?.toString().trim() === normalizedPhone,
        );

        if (rowsList && existingReduxIndex && existingReduxIndex !== -1) {
          const updatedRowsList = [...rowsList];
          updatedRowsList[existingReduxIndex] = {
            ...newRowData,
            check: 1,
          };
          setRowsList(updatedRowsList);
        }
      }

      setOpenDialog(false);
      setShowOverwriteDialog(false);
      resetNewAudience();
      setRequiredFieldsError({
        phone: false,
        name: false,
      });

      dispatch(
        showMessage({
          type: "success",
          message: "Contact information updated successfully",
          displayAs: "snackbar",
        }),
      );
    }
  };

  const handleOverwriteCancel = () => {
    setShowOverwriteDialog(false);
    setExistingRowData(null);
    setNewRowData(null);
  };

  const getFieldDifferences = (
    existing: any,
    newData: any,
  ): Array<{
    field: string;
    existing: string;
    new: string;
  }> => {
    if (!existing || !newData) return [];

    const differences: Array<{
      field: string;
      existing: string;
      new: string;
    }> = [];
    const allFields = new Set([
      ...Object.keys(existing),
      ...Object.keys(newData),
    ]);

    const fieldNameMapping: { [key: string]: string } = {
      phone: "Phone",
      name: "Name",
      dob: "Date of Birth",
      city: "City",
      event_name: "Event Name",
    };

    allFields.forEach((field) => {
      if (EXCLUDED_COMPARE_FIELDS.includes(field)) return;

      const existingValue = existing[field];
      const newValue = newData[field];

      if (existingValue !== newValue) {
        differences.push({
          field:
            fieldNameMapping[field] ||
            field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
          existing: existingValue || "---",
          new: newValue || "---",
        });
      }
    });

    return differences;
  };

  const renderDynamicFields = () => {
    if (!tableHeaders) return null;

    return tableHeaders
      .filter((header) => !["check", "id", "phone", "name"].includes(header))
      .map((header) => {
        const fieldType = header.includes("date") ? "date" : "text";

        return (
          <Grid item xs={6} lg={6} key={header}>
            <CustomFormLabel>{formatHeaderText(header)}</CustomFormLabel>
            {fieldType === "date" ? (
              <CustomDatePicker
                fullWidth
                value={
                  (newAudience[header as keyof typeof newAudience] as string) ||
                  null
                }
                onChange={(newDate) =>
                  setNewAudience({
                    ...newAudience,
                    [header]: newDate,
                  })
                }
              />
            ) : (
              <CustomTextField
                label=""
                variant="outlined"
                fullWidth
                value={newAudience[header as keyof typeof newAudience] || ""}
                onChange={(e) =>
                  setNewAudience({
                    ...newAudience,
                    [header]: e.target.value,
                  })
                }
              />
            )}
          </Grid>
        );
      });
  };

  // const fetchData = React.useCallback(async () => {
  //   try {
  //     setLoading(true);

  //     await dispatch(
  //       fetchQuickSendCampaignListAsync(
  //         marketCampaignId as string,
  //         companyOutlet.comapny.company_outlet_uuid,
  //         page + 1,
  //         debouncedContactNumber,
  //         debouncedGuestName,
  //         rowsPerPage,
  //       ),
  //     );
  //   } catch (error: any) {
  //     dispatch(
  //       showMessage({
  //         type: "error",
  //         message: error.response.data.message,
  //         displayAs: "snackbar",
  //       }),
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [
  //   companyOutlet.comapny.company_outlet_uuid,
  //   page,
  //   rowsPerPage,
  //   debouncedContactNumber,
  //   debouncedGuestName,
  //   dispatch,
  //   marketCampaignId,
  // ]);

  const getPanelTitle = () => {
    if (mode === "QUICK_SEND") return "Quick Send Campaign List";
    return `Audience Details`;
  };

  const formatHeaderText = (header: string) => {
    return header
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const sortHeaders = (headers: string[]) => {
    const priorityHeaders = ["check", "phone", "name"];
    const otherHeaders = headers.filter(
      (header) => !priorityHeaders.includes(header),
    );

    return [
      ...priorityHeaders.filter((header) => headers.includes(header)),
      ...otherHeaders,
    ];
  };

  const renderCellContent = (row: any, header: string) => {
    const value = row[header];

    if (header === "check") {
      return (
        <CustomCheckbox
          checked={Boolean(row.check) || false}
          onChange={handleCheckBox(row.phone)}
          disabled={!isEditable}
        />
      );
    }

    if (header.includes("date") || header.includes("followup_date")) {
      return ftDate(value);
    }

    return value;
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (/^\d*$/.test(value) && value.length <= 10) {
      setContactNumberSearch(value);
    }
  };

  // React.useEffect(() => {
  //   if (!open || !marketCampaignId) return;

  //   const timer = setTimeout(() => {
  //     fetchData();
  //   }, 100);

  //   return () => clearTimeout(timer);
  // }, [
  //   open,
  //   marketCampaignId,
  //   page,
  //   rowsPerPage,
  //   debouncedContactNumber,
  //   debouncedGuestName,
  //   fetchData,
  // ]);

  // React.useEffect(() => {
  //   if (!quickSendList?.length) return;
  //   if (isSaving) return;

  //   setRowsList((prev) => {
  //     return quickSendList.map((apiRow) => {
  //       const key = apiRow.phone?.toString().trim();
  //       const editedRow = editedRowsMap[key];

  //       if (editedRow) {
  //         // ✅ merge user-edited state
  //         return {
  //           ...apiRow,
  //           ...editedRow,
  //         };
  //       }

  //       // ✅ first time seeing this row
  //       return {
  //         ...apiRow,
  //         check: apiRow.check ?? 1,
  //         initialCheck: apiRow.check ?? 1,
  //         isRecordUpdated: false,
  //         currentPageNo: page,
  //       };
  //     });
  //   });
  // }, [quickSendList, editedRowsMap, page]);

  React.useEffect(() => {
    if (!newQuickSendList?.length) return;
    if (isSaving) return;

    // setRowsList((prev) => {
    //   return newQuickSendList?.map((apiRow) => {
    //     const key = apiRow.phone?.toString().trim();
    //     const editedRow = editedRowsMap[key];

    //     if (editedRow) {
    //       // ✅ merge user-edited state
    //       return {
    //         ...apiRow,
    //         ...editedRow,
    //       };
    //     }

    //     // ✅ first time seeing this row
    //     return {
    //       ...apiRow,
    //       check: apiRow.check ?? 1,
    //       initialCheck: apiRow.check ?? 1,
    //       isRecordUpdated: false,
    //       currentPageNo: page,
    //     };
    //   });
    // });
  }, [newQuickSendList, editedRowsMap, page]);

  return (
    <>
      <RightPanel
        open={open}
        heading={getPanelTitle()}
        onClose={onClose}
        width="100%"
        isWrappedWithForm
        hideCrossTopButton={true}
        actionButtons={() => {
          return (
            <Stack
              direction={"row"}
              spacing={1}
              justifyContent={"flex-end"}
              mb={6}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<NavigateBefore />}
                onClick={() => {
                  navigate("/market-campaign");
                }}
              >
                Back to Campaigns
              </Button>

              <Button
                variant="contained"
                startIcon={<NavigateBefore />}
                onClick={() => {
                  onStateChange({
                    ...state,
                    activeStep: 0,
                    maxAllowedSteps: draftStepData?.current_step,
                  });
                }}
              >
                Back to Step 1
              </Button>

              {isEditable && updatedRowsList.length !== 0 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveAndNextAsync}
                >
                  Save & Next
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  Next
                </Button>
              )}

              {campaignBasicInfo?.status === "DRAFT" && (
                <Button variant="contained" color="primary" onClick={onClose}>
                  Close
                </Button>
              )}
            </Stack>
          );
        }}
      >
        <Grid
          sx={{
            display: "flex",
            margin: "0px",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: `${isDesktop ? "row" : "column"}`,
          }}
        >
          <Box
            sx={{
              paddingBottom: "10px",
              display: "flex",
              gap: 2,
              my: 1,
            }}
          >
            <CustomTextField
              label="Search by Phone"
              variant="outlined"
              fullWidth
              value={contactNumberSearch}
              onChange={handlePhoneNumberChange}
              // sx={{ minWidth: 250 }}
              sx={isDesktop ? { minWidth: 250 } : {}}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10,
              }}
            />

            <CustomTextField
              label="Search by Name"
              variant="outlined"
              fullWidth
              value={guestNameSearch}
              onChange={(e) => {
                const value = e.target.value;

                setGuestNameSearch(value);
              }}
              sx={isDesktop ? { minWidth: 250 } : {}}
              InputProps={{
                endAdornment: guestNameSearch && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setGuestNameSearch("");
                      }}
                      edge="end"
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 2,
                backgroundColor: theme.palette.primary.main,
                borderRadius: "4px",
                height: "40px",
              }}
            >
              <Typography variant="body1" color="white">
                {`${selectedCustomers} customers selected`}
              </Typography>
            </Box>

            <Button
              disabled={!isEditable}
              variant="contained"
              onClick={() => {
                setOpenDialog(true);
              }}
            >
              Add Audience
            </Button>
            <CustomSwitch
              name="isIncludeSelected"
              leftText="Include"
              rightText="Exclude"
              checked={isIncludeSelected}
              disabled={!isEditable}
              onChange={(e) => setIsIncludeSelected(e.target.checked)}
            />
          </Box>
        </Grid>

        {isDesktop ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "primary.main" }}>
                  {tableHeaders &&
                    sortHeaders(tableHeaders).map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          color: "#fff",
                          fontSize: "0.95rem",
                          fontWeight: 500,
                        }}
                      >
                        {header === "check" ? (
                          <CustomCheckbox
                            checked={allChecked}
                            onChange={handleCheckBoxAll}
                            disabled={!isEditable}
                          />
                        ) : (
                          formatHeaderText(header)
                        )}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {displayRows?.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {tableHeaders &&
                        sortHeaders(tableHeaders).map((header) => (
                          <TableCell
                            sx={{
                              minWidth: `${
                                header === "check" || header === "id"
                                  ? "10px"
                                  : "150px"
                              }`,
                            }}
                            key={`${index}-${header}`}
                          >
                            {renderCellContent(row, header) || "--"}
                          </TableCell>
                        ))}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
              }}
              component="div"
              count={totalCombinedRecords}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        ) : (
          <Box sx={{ display: { xs: "block", md: "none" }, mt: 2 }}>
            {displayRows?.map((row, index) => (
              <Card
                key={index}
                sx={{
                  boxShadow: 1,
                  borderRadius: 3,
                  p: 1,
                  mb: 2,
                  backgroundColor: "#fafafa",
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <CustomCheckbox
                      checked={Boolean(row.check) || false}
                      onChange={handleCheckBox(row.phone)}
                      disabled={!isEditable}
                    />
                  </Box>

                  {tableHeaders && (
                    <Grid container spacing={2}>
                      {sortHeaders(tableHeaders)
                        .filter(
                          (header) => header !== "check" && header !== "id",
                        )
                        .map((header, index) => (
                          <Grid
                            key={header}
                            item
                            xs={6}
                            sx={{
                              mb: 2,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              color="text.secondary"
                            >
                              {formatHeaderText(header)}
                            </Typography>
                            <Typography variant="body1">
                              {renderCellContent(row, header)}
                            </Typography>
                          </Grid>
                        ))}
                    </Grid>
                  )}
                </CardContent>
              </Card>
            ))}

            <TablePagination
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
              }}
              component="div"
              count={totalCombinedRecords}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        )}
        {/* Create Audience Dialog */}
        <Dialog
          title="Create Audience"
          size="md"
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
            resetNewAudience();
            setRequiredFieldsError({
              phone: false,
              name: false,
            });
          }}
        >
          <DialogContent sx={{ marginRight: 3 }}>
            <Stack spacing={3}>
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", ml: 0, mb: 4 }}
              >
                <Grid item xs={6} lg={6}>
                  <CustomFormLabel>Phone *</CustomFormLabel>
                  <MuiNumberField
                    label=""
                    name="phone"
                    value={newAudience.phone || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      // allow only digits & max 10 chars
                      if (/^\d*$/.test(value) && value.length <= 10) {
                        setNewAudience({
                          ...newAudience,
                          phone: value,
                        });

                        setRequiredFieldsError({
                          ...requiredFieldsError,
                          phone: value.length !== 10,
                        });
                      }
                    }}
                    error={
                      requiredFieldsError.phone
                        ? "Phone number must be exactly 10 digits"
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={6} lg={6}>
                  <CustomFormLabel>Name *</CustomFormLabel>
                  <CustomTextField
                    label=""
                    variant="outlined"
                    fullWidth
                    value={newAudience.name || ""}
                    onChange={(e) => {
                      setNewAudience({
                        ...newAudience,

                        name: e.target.value,
                      });
                      setRequiredFieldsError({
                        ...requiredFieldsError,

                        name: false,
                      });
                    }}
                    error={requiredFieldsError.name}
                    helperText={
                      requiredFieldsError.name ? "Guest name is required" : ""
                    }
                  />
                </Grid>
              </Grid>

              <Grid
                xs={12}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography
                  variant="h5"
                  gutterBottom
                  fontWeight={900}
                  textAlign={"center"}
                  width={"300px"}
                  sx={(theme: Theme) => ({
                    background: theme.palette.primary.main,
                    color: "#fff",
                    py: 1,

                    borderRadius: 6,
                  })}
                >
                  Optional Fields
                </Typography>
              </Grid>

              <Grid container spacing={2}>
                {renderDynamicFields()}
              </Grid>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ pb: 4 }}>
            <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateAudience}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* Overwrite Confirmation Dialog */}
        <Dialog
          title="Contact Number Already Exists"
          size="md"
          open={showOverwriteDialog}
          onClose={handleOverwriteCancel}
          actions={[
            {
              type: "button",
              label: "Cancel",
              variant: "outlined",
              onClick: handleOverwriteCancel,
            },
            {
              type: "submit",
              label: "Yes, Overwrite",
              variant: "contained",
              onClick: handleOverwriteConfirm,
            },
          ]}
        >
          <DialogContent>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Do you want to overwrite the existing data with the new
              information?
            </Typography>

            {existingRowData && newRowData && (
              <TableContainer>
                <Table
                  sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "18px" }}>
                        Field
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "18px" }}>
                        Previous Value
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "18px" }}>
                        Updated Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getFieldDifferences(existingRowData, newRowData).map(
                      (diff, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:hover": {
                              backgroundColor: "grey.25",
                            },
                            "&:last-child .MuiTableCell-root": {
                              borderBottom: "none",
                            },
                          }}
                        >
                          <TableCell
                            sx={{
                              fontWeight: 500,
                              fontSize: "13px",
                              color: "text.primary",
                              verticalAlign: "top",
                              pt: 2.5,
                            }}
                          >
                            {diff.field}
                          </TableCell>
                          <TableCell sx={{ verticalAlign: "top" }}>
                            <Box
                              sx={{
                                p: 1.5,
                                borderRadius: 1,
                                backgroundColor: "#fef2f2",
                                border: "1px solid #fecaca",
                                position: "relative",
                              }}
                            >
                              <Chip
                                label="OLD"
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -8,
                                  left: 8,
                                  backgroundColor: "#dc2626",
                                  color: "white",
                                  fontSize: "10px",
                                  height: 16,
                                  "& .MuiChip-label": {
                                    px: 1,
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  color: "#991b1b",
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  mt: 0.5,
                                  wordBreak: "break-word",
                                }}
                              >
                                {diff.existing}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ verticalAlign: "top" }}>
                            <Box
                              sx={{
                                p: 1.5,
                                borderRadius: 1,
                                backgroundColor: "#f0fdf4",
                                border: "1px solid #bbf7d0",
                                position: "relative",
                              }}
                            >
                              <Chip
                                label="NEW"
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -8,
                                  left: 8,
                                  backgroundColor: "#16a34a",
                                  color: "white",
                                  fontSize: "10px",
                                  height: 16,
                                  "& .MuiChip-label": {
                                    px: 1,
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  color: "#166534",
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  mt: 0.5,
                                  wordBreak: "break-word",
                                }}
                              >
                                {diff.new}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
        </Dialog>
      </RightPanel>
      <LoadingDialog open={loading} />
    </>
  );
};
